import React from "react";

/**
 * The Curated Mile brand mark — uses the official monogram PNG from /brand/.
 * Sizes:
 *   sm  → 32px height (top-bar headers)
 *   md  → 48px height (default)
 *   lg  → 96px height (login page)
 *   xl  → 140px height (hero / email header)
 * `showRule` and `subtitle` are kept for backwards-compat with existing usages
 * but the image already contains a rule and the wordmark, so they are ignored
 * unless subtitle is set (rendered below).
 */
export function TCMLogo({ size = "md", tone = "navy", showRule = false, subtitle }) {
  const heights = { sm: 32, md: 48, lg: 96, xl: 140 };
  const h = heights[size] || heights.md;
  // Transparent PNG blends with any background — used everywhere in the portal.
  const src = "/brand/tcm-logo-transparent.png";
  return (
    <span className="inline-flex flex-col items-start leading-none" data-testid="tcm-logo">
      <img
        src={src}
        alt="The Curated Mile"
        style={{ height: `${h}px`, width: "auto", display: "block", background: "transparent" }}
        draggable={false}
      />
      {subtitle && (
        <span className="text-[9px] tracking-[0.24em] uppercase opacity-60 mt-2 text-[color:var(--tcm-navy-70)]">
          {subtitle}
        </span>
      )}
    </span>
  );
}

export default TCMLogo;
